import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { UpgradeModalProvider } from './contexts/UpgradeModalContext';
import { UpgradeModal } from './components/UpgradeModal';
import { ProtectedRoute, PublicRoute } from './components/ProtectedRoute';
import { AuthCallback } from './components/AuthCallback';
import { Toaster } from './components/ui/sonner';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { FormBuilderPage } from './pages/FormBuilderPage';
import { SubmissionsPage } from './pages/SubmissionsPage';
import { PublicFormPage } from './pages/PublicFormPage';
import { AdminPage } from './pages/AdminPage';
import { AdminVouchersPage } from './pages/AdminVouchersPage';
import { AdminEmailSettingsPage } from './pages/AdminEmailSettingsPage';
import { PricingPage } from './pages/PricingPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { BillingPage } from './pages/BillingPage';
import { GuestFormBuilderPage } from './pages/GuestFormBuilderPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import { ProfilePage } from './pages/ProfilePage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { VerifyEmailPage } from './pages/Auth/VerifyEmailPage';
import { TeamPage } from './pages/TeamPage';
import { CollaborateFormPage } from './pages/CollaborateFormPage';
import { AcceptInvitePage } from './pages/AcceptInvitePage';
import { SecurityPage } from './pages/SecurityPage';
import { VerifyPage } from './pages/VerifyPage';
import { ConsumerConsentPage } from './pages/ConsumerConsentPage';
import { FormlioSignPage } from './pages/FormlioSignPage';

function App() {
  return (
    <AuthProvider>
      <UpgradeModalProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/consumer-consent" element={<ConsumerConsentPage />} />
          <Route path="/formlio-sign" element={<FormlioSignPage />} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/signup" element={<PublicRoute><SignupPage /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
          <Route path="/admin_login" element={<AdminLoginPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/templates/forms" element={<TemplatesPage />} />
          <Route path="/templates/quiz" element={<TemplatesPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/try-builder" element={<GuestFormBuilderPage />} />
          
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/submissions" element={<ProtectedRoute><SubmissionsPage /></ProtectedRoute>} />
          <Route path="/forms/:formId/builder" element={<ProtectedRoute><FormBuilderPage /></ProtectedRoute>} />
          <Route path="/forms/:formId/submissions" element={<ProtectedRoute><SubmissionsPage /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
          <Route path="/billing/success" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
          <Route path="/admin/email-settings" element={<ProtectedRoute><AdminEmailSettingsPage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminUsersPage /></ProtectedRoute>} />
          <Route path="/admin/vouchers" element={<ProtectedRoute><AdminVouchersPage /></ProtectedRoute>} />
          <Route path="/team" element={<ProtectedRoute><TeamPage /></ProtectedRoute>} />
          
          <Route path="/f/:formId" element={<PublicFormPage />} />
          <Route path="/forms/collaborate/:token" element={<CollaborateFormPage />} />
          <Route path="/team/accept-invite/:token" element={<AcceptInvitePage />} />
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
        <UpgradeModal />
      </BrowserRouter>
      </UpgradeModalProvider>
    </AuthProvider>
  );
}

export default App;